export let baseUrl = process.env.VUE_APP_ENDPOINT;
export let stripeKey = "pk_live_51I8oSDHGmgeQzxE0mtjArlHWmlXm6IUSTYWL20TZkRygJsYscc24PkXne77A32rypfMjKvLorNIZPXjenBGbXaK200lRtMe8Y5"; //process.env.VUE_APP_STRIPE_KEY;

baseUrl = process.env.VUE_APP_ENDPOINT;